import React from 'react';
import { Link, Outlet } from 'react-router-dom';

export default function PublicLayout() {
  return (
    <>
      <header className="public-header">
        <Link className="brand" to="/">
          <span className="brand-mark">SR</span>
          SmartRent
        </Link>
        <nav className="public-nav" aria-label="Hauptnavigation">
          <Link to="/#maschinen">Maschinen</Link>
          <Link to="/login">Vermieter-Login</Link>
          <Link className="nav-cta" to="/anfrage">Mietanfrage starten</Link>
        </nav>
      </header>
      <main><Outlet /></main>
      <footer className="public-footer">
        <div className="public-footer-inner">
          <strong>SmartRent</strong>
          <span>Maschinenbedarf strukturiert anfragen · Anonyme Preisinformationen erhalten</span>
        </div>
      </footer>
    </>
  );
}
